export default {
    namespaced: true,
    state: {
        loading: false,
        processing: false,
        collapsed: null,
        page_size: -1,
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        start(state) {
            state.loading = true
        },
        stop(state) {
            state.loading = false
        },
        setCollapsed(state, value) {
            state.collapsed = value;
            localStorage.setItem('collapsed', state.collapsed);
        },
        setPageSize(state,value) {
            state.page_size = value;
            localStorage.setItem('page_size', state.page_size.toString());
        }
    },
    actions: {},
    getters: {
        isCollapsed(state) {
            if (state.collapsed === null) {
                let col = localStorage.getItem('collapsed');
                if (col) {
                    state.collapsed = col === "true"
                } else {
                    state.collapsed = window.innerWidth < 1200;
                    localStorage.setItem('collapsed', state.collapsed);
                }
            }
            return state.collapsed;
        },
        pageSize(state) {
            if (state.page_size === -1) {
                let size = localStorage.getItem('page_size');
                if (size) {
                    state.page_size = parseInt(size) || 10;
                } else {
                    state.page_size = 10;
                }
                if (state.page_size !== parseInt(size))
                    localStorage.setItem('page_size', state.page_size.toString());
            }
            return state.page_size;
        }
    }
}
